import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PageSizeButton from '../../../components/PageSizeButton/PageSizeButton';
import DspxPagination from '../../../components/DspxPagination/DspxPagination';
import documentListActions from '../store/actions/document-list.actions';
import styles from './table.module.scss';

const PaginationBlock = ({
  lastIndexOnPage,
  firstIndexOnPage,
  currentPageNumber,
  maxPage,
  setPageNumber,
  selectedDocumentsAmount,
}) => {
  const pageSize = useSelector((store) => store.documentListStore.pageSize);
  const documents = useSelector((store) => store.documentsStore.documents);

  const dispatch = useDispatch();

  const handlePageSizeChange = (newPageSize) => {
    dispatch(documentListActions.setPageSize(newPageSize));
  }

  return (
    <div className={styles.paginationBlock}>
      <PageSizeButton 
        getPopupContainer={() => document.getElementById('docTableContainer')}
        pageSize={pageSize}
        setPageSize={handlePageSizeChange}
        className={styles.pageSizeBtnWrap}
        buttonClassName={styles.pageSizeBtn}
      />
      {/* {selectedDocumentsAmount > 0 && ( */}
        <span className={styles.tdItem} style={{ fontSize: '16px' }}>
          Выбрано документов: {selectedDocumentsAmount} из {documents.length}
        </span>
      {/* )} */}

      <DspxPagination
        current={currentPageNumber + 1}
        total={documents?.length || 0}
        pageSize={pageSize}
        showQuickJumper={maxPage > 9}
        quickJumperToStart
        onChange={setPageNumber}
        hideOnSinglePage={false}
      />
    </div>
  );
};

export default PaginationBlock;